import { render, staticRenderFns } from "./ChangeSender.vue?vue&type=template&id=690ca980"
import script from "./ChangeSender.vue?vue&type=script&lang=js"
export * from "./ChangeSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports